import React from 'react'
import cx from 'classnames'

import { Box } from 'components/layout'

import s from './CardContainer.scss'


const CardContainer = ({ children, className, onClick }) => (
  <Box
    className={cx(s.cardContainer, className)}
    p={24}
    onClick={onClick}
  >
    {children}
  </Box>
)


export default CardContainer
